import type { ComponentProps } from 'react'
import Submit from '../../shared/Submit'

type Props = ComponentProps<typeof Submit>

export default function Step7_Submit(props: Props) {
  return <Submit {...props} />
}

